var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d_inblock",style:(Object.assign({}, _vm.padding, _vm.customStyle))},[_c('div',{staticClass:"badge-container",style:({
      verticalalign: _vm.align,
    })},[_vm._t("default"),(_vm.on)?_c('div',{staticClass:"badge",style:({ top: (_vm.top + "px"), right: (_vm.right + "px"), width: (_vm.size + "px"), height: (_vm.size + "px") })}):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }